import { Button, Carousel } from 'src/core/components';
import { hoc } from 'src/core/utils';
import { Product } from './product';
import { useProductsListProps } from './products-list.props';
import styles from './products-list.module.scss';

/**
 * <ProductsList />
 */
const ProductsList = hoc(
  useProductsListProps,
  ({ width, products, locale, page, isShowAll, showAll }) => (
    <div className={styles.products_carousel} id='tastes'>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{page.productsCarousel.title[locale]}</h2>
        <p className={styles.text}>{page.productsCarousel.text[locale]}</p>
      </div>
      <ul className={styles.list}>
        {products.map((product, index) => {
          if (!isShowAll && index > 2) return;
          return (
            <Product
              key={index}
              index={index}
              product={product}
              locale={locale}
              productsLength={products.length}
            />
          );
        })}
      </ul>
      {!isShowAll && (
        <div className={styles.btn_wrapper}>
          <Button className={styles.btn} onClick={showAll}>
            {page.productsCarousel.btn[locale]}
          </Button>
        </div>
      )}
    </div>
  )
);

export { ProductsList };
